import {
  AnyIconProps,
  IconBraces,
  IconDocumentTif,
  IconImage,
} from '@hawkins/assets';
import {
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
  Tooltip,
} from '@hawkins/components';
import { ComponentType } from 'react';
import { downloadFDL } from './downloadFDL';
import { downloadFramingChartImage } from './downloadFramingChartImage';
import { FramingChartProps } from './types';
import styles from './FramingChartDownloader.module.css';

export default function FramingChartDownloader({
  desqueezedFramingChartProps,
  framingChartProps,
  framingIntentLabelError,
}: {
  desqueezedFramingChartProps?: FramingChartProps;
  framingChartProps: FramingChartProps;
  framingIntentLabelError?: boolean;
}) {
  const downloadFDLDisabled = framingIntentLabelError;

  const isAnamorphic = framingChartProps.lensSqueezeFactor !== 1;

  const imageDownloadButton = (
    icon: ComponentType<AnyIconProps>,
    label: string,
    anamorphicCallback: () => void,
    sphericalCallback: () => void
  ) =>
    isAnamorphic ? (
      <Menu
        showCaret
        trigger={
          <Button aria-label="showCaret" icon={icon}>
            {label}
          </Button>
        }
      >
        <MenuItem onClick={anamorphicCallback}>Anamorphic</MenuItem>
        <MenuItem onClick={sphericalCallback}>De-Squeezed</MenuItem>
      </Menu>
    ) : (
      <Button
        variant="primary"
        icon={icon}
        onClick={() => sphericalCallback()}
      >
        {label}
      </Button>
    );

  return (
    <ButtonGroup className={styles.downloadButtonGroup}>
      {imageDownloadButton(
        IconImage,
        'Download PNG',
        () => downloadFramingChartImage('png', framingChartProps),
        () =>
          downloadFramingChartImage(
            'png',
            desqueezedFramingChartProps || framingChartProps
          )
      )}
      {imageDownloadButton(
        IconDocumentTif,
        'Download TIFF',
        () => downloadFramingChartImage('tiff', framingChartProps),
        () =>
          downloadFramingChartImage(
            'tiff',
            desqueezedFramingChartProps || framingChartProps
          )
      )}
      <Tooltip
        label={
          downloadFDLDisabled
            ? 'Please fix framing decision input errors'
            : ''
        }
        placement="top"
      >
        <Button
          variant="primary"
          icon={IconBraces}
          onClick={() => downloadFDL(framingChartProps)}
          disabled={downloadFDLDisabled}
        >
          Download FDL
        </Button>
      </Tooltip>
    </ButtonGroup>
  );
}
